module.exports = __webpack_public_path__ + "static/media/Dashboard.2e7b63c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Dashboard.png
// module id = 459
// module chunks = 1